import { ConnectivityState, StorageType } from '../shared';

export interface Location {
  name: string;
  uid: string;
  displayName: string;
  description?: string;
  uri: string;
  credential?: string;
  storageType: StorageType;
  connectivityState: ConnectivityState;
  createTime?: string;
  updateTime?: string;
  etag?: string;
}

export interface CreateLocationRequest {
  location: Omit<Location, 'uid' | 'storageType' | 'connectivityState' | 'createTime' | 'updateTime'>;
  locationId?: string;
  validateOnly?: boolean;
}

export interface UpdateLocationRequest {
  location: Partial<Location> & { name: string };
  updateMask?: string[];
}

export interface ListLocationsParams {
  pageSize?: number;
  pageToken?: string;
  filter?: string;
  orderBy?: string;
}

export interface ListLocationsResponse {
  locations: Location[];
  nextPageToken?: string;
  totalSize: number;
}

export interface LocationDisplay extends Omit<Location, 'credential'> {
  credential: {
    name: string;
    uid: string;
    displayName: string;
  } | null;
}

export const transformLocationToDisplay = (
  location: Location,
  credentials: { name: string; uid: string; displayName: string }[],
): LocationDisplay => {
  const credential =
    credentials.find((cred) => cred.name === location.credential || cred.uid === location.credential) ?? null;

  return {
    ...location,
    credential,
  };
};

export interface TestConnectivityResponse {
  connectivityState: ConnectivityState;
  message: string;
  latency?: string;
}
